import { Group, Image, Divider, Burger } from "@mantine/core";
import SidebarNavLinks from "./SidebarNavlinks";
import SidebarOrgSelect from "./SidebarOrgSelect";
import SidebarUserButton from "./SidebarUserButton";
import classes from "./Sidebar.module.css";
import { useRouter } from "next/navigation";

interface SidebarProps {
  toggle: () => void;
  opened: boolean;
  onNavigate?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ toggle, opened, onNavigate }) => {
  const router = useRouter();

  return (
    <nav className={classes.navbar}>
      <div className={classes.header}>
        <Group align="center">
          <Burger
            opened={opened}
            onClick={toggle}
            hiddenFrom="sm"
            size="sm"
            className={classes.burgerButton}
          />
          <Image
            src="/music-lab-logo.png"
            alt="Music LAB logo"
            w={120}
            mb={24}
            onClick={() => {
              router.push("/batches");
              onNavigate?.();
            }}
          />
        </Group>
      </div>
      <Divider color="#262626" />
      <SidebarOrgSelect />
      <Divider color="#262626" />
      <SidebarNavLinks onNavigate={onNavigate} />
      <div className={classes.footer}>
        <SidebarUserButton />
      </div>
    </nav>
  );
};

export default Sidebar;
